const translations = {
    loading: 'Iekraušana',
    loading_data: 'Datu ielāde ...',
    validate_email: 'Tā nav pareiza e-pasta adrese',
    validate_required: 'Šis lauks ir obligāts',
    validate_the_same: 'Abām parolēm jābūt vienādām',
    sign_in: 'Pieslēgties',
    sign_up__invitation: 'Vai jums nav konts?',
    sign_up: 'Reģistrēties!',
    forgot_password: 'Vai jūs atceraties paroli?',
    error_occurred: 'Radās kļūda!',
    activation_token_broken: 'Aktivizācijas marķieris ir nepareizs.',
    return_to_login: 'Atgriezties pieteikties',
    activation_success: 'Paldies! Jūsu konts tagad ir aktīvs.',
    forgot_password_submit: 'Atiestatiet paroli',
    password: 'Parole',
    password_confirmation: 'atkārtojiet paroli',
    email: 'E-pasta ziņojums',
    remember_me: 'Atceries mani',
    welcome: 'Laipni lūdzam!',
    log_in_to_access: 'Piesakieties, lai sāktu',
    password_forgot_message: 'Vai jūs nevarat pieteikties? Ievadiet savu e-pasta adresi, lai atiestatītu paroli!',
    back_to: 'atgriezties',
    sign_in_page: 'Pieslēgties',
    select: 'Izvēlieties ...',
    select_new: 'Izveidot:',
    invitation_sent: 'Uzaicinājums nosūtīts',
    users_custom_company_data: 'Izmantojiet citas uzņēmuma datus',
    or_just_attachment_name: 'Vai vienkārši pievieno pielikuma nosaukumu:',
    other_docs: 'Citi dokumenti:',
    readBy: 'Lasīts:',
};
export default translations;
